import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const AuthProtected = ({ children }) => {
  const location = useLocation();
  const [isValid, setIsValid] = useState(null); // null = loading

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (token) {
      try {
        // OPTIONAL: decode JWT to check if expired
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp && decoded.exp < currentTime) {
          throw new Error("Token expired");
        }

       
        setIsValid(true);
      } catch (error) {
        console.warn("Invalid token:", error.message);
        sessionStorage.removeItem("authToken");
        setIsValid(false);
      }
    } else {
      setIsValid(false);
    }
  }, []);

  if (isValid === null) return <div></div>; // Optional spinner

  if (!isValid) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
};

export { AuthProtected };
